import axios from 'axios';
const API_URL = process.env.REACT_APP_API_BASE_URL;


const axiosInstance = axios.create({
    baseURL: API_URL,
});

axiosInstance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        const tokenId = localStorage.getItem('token_id');

        // console.log(token)
        // console.log( tokenId)
        
        if (token) {
            config.headers['Token_Data'] = token;
            config.headers['Token_ID'] = tokenId;
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Add a response interceptor to handle token expiration
axiosInstance.interceptors.response.use(
    (response) => {

        // console.log(response,"respon ein asxios ")
        if(!response.data.status && response.data.message === "Invalid Token" ){
            localStorage.removeItem('token');
            localStorage.removeItem('token_id');
            window.location.href = '/login';
        }

        return response;
    },
    (error) => {
        const status = error.response ? error.response.status : null;

        if (status === 401 || status === 403) {

            localStorage.removeItem('token');
            localStorage.removeItem('token_id');
            window.location.href = '/login';
        }

        return Promise.reject(error); 
    }
);


export const apiService = {

    // A function to make a GET request
    get: async (url,config = {}) => {
        try {
            // setAxiosDefaults()
            const response = await axiosInstance.get(url, config);
            
        // If responseType is blob, return the whole response
        if (config.responseType === 'blob') {
            return response;
        }
            return response.data;
        } catch (error) {
            return error;
        }
    },

    // A function to make a POST request
    post: async (url, data = {}, config = {}) => {
        try {
            const response = await axiosInstance.post(API_URL + url, data, config);
            return response.data;
        } catch (error) {
            return error;
        }
    },

    // A function to make a PUT request
    put: async (url, data = {}, config = {}) => {
        try {
            const response = await axiosInstance.put(API_URL + url, data, config);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    // A function to make a DELETE request
    delete: async (url, config = {}) => {
        try {
            const response = await axiosInstance.delete(API_URL + url, config);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
};
    